import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from "@angular/core";
import {
  PanelCommandItem,
  PanelCommandKey
} from "../../../interfaces/panel-alerts.interface";

/** Clase CSS del punto de estado segun el estado visual del comando. */
const DOT_CLASS: { [status: string]: string } = {
  idle: "is-idle",
  waiting: "is-waiting",
  finished: "is-finished"
};

/** Clave i18n de la descripcion del estado, que se usa como tooltip. */
const STATUS_LABEL: { [status: string]: string } = {
  idle: "testing.command-idle",
  waiting: "testing.command-waiting",
  finished: "testing.command-finished"
};

/** Color del icono SVG segun el estado visual del comando. */
const ICON_COLOR: { [status: string]: string } = {
  idle: "#999999",
  waiting: "#1b7fd4",
  finished: "#009e0f"
};

/** Icono FontAwesome 4 del badge de estado; sin icono mientras no se envia. */
const STATUS_ICON: { [status: string]: string } = {
  idle: "",
  waiting: "fa-clock",
  finished: "fa-check"
};

/**
 * Boton de un comando del panel de testeos.
 *
 * Muestra cuantos equipos han respondido y un punto con el estado del proceso,
 * reducido a los tres del diseno: gris sin enviar, azul esperando respuesta y
 * verde proceso terminado.
 */
@Component({
  selector: "app-panel-command-button",
  templateUrl: "./command-button.html",
  styleUrls: ["../commands.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelCommandButtonComponent implements OnChanges {
  @Input() item: PanelCommandItem;

  /** Se emite con el comando que hay que lanzar. */
  @Output() run = new EventEmitter<PanelCommandKey>();

  /** Clase del punto de estado, precalculada para no llamar metodos en el template. */
  dotClass = DOT_CLASS.idle;
  /** Clave i18n del tooltip del estado. */
  statusLabel = STATUS_LABEL.idle;
  /** Icono del badge de estado (reloj azul esperando, check verde terminado). */
  statusIcon = STATUS_ICON.idle;
  /** Ruta del icono del comando. */
  iconUrl = "";
  /** Color del icono SVG segun el estado del comando. */
  iconColor = ICON_COLOR.idle;
  /** Ancho del icono SVG derivado de la definicion del comando. */
  iconWidth = "18px";
  /** Alto del icono SVG derivado de la definicion del comando. */
  iconHeight = "18px";
  /** Clase del interruptor, fija segun el comando: solo es representativa. */
  toggleClass = "is-off";

  /**
   * Precalcula la clase y el tooltip del estado para no llamar metodos desde
   * la plantilla.
   * @returns void
   */
  ngOnChanges(): void {
    if (!this.item) {
      return;
    }
    this.dotClass = DOT_CLASS[this.item.status] || DOT_CLASS.idle;
    this.statusLabel = STATUS_LABEL[this.item.status] || STATUS_LABEL.idle;
    this.statusIcon = STATUS_ICON[this.item.status] || STATUS_ICON.idle;
    this.iconColor = ICON_COLOR[this.item.status] || ICON_COLOR.idle;
    this.iconUrl = `img/icons/${this.item.icon}`;
    this.iconWidth = this.item.iconWidth || "18px";
    this.iconHeight = this.item.iconHeight || "18px";
    /* El interruptor es solo representativo y no se mueve: Encender siempre
       encendido y Apagar siempre apagado. El estado lo da el color de la card. */
    this.toggleClass = this.item.key === "turn_on" ? "is-on" : "is-off";
  }

  /** Lanza el comando si hay equipos a los que enviarlo. */
  onRun(): void {
    if (this.item && !this.item.disabled) {
      this.run.emit(this.item.key);
    }
  }
}
